import { FC } from 'react';
import styled from '@emotion/styled';
import QcsAlert from '../basic/QcsAlert';

import { useTranslation } from 'react-i18next';

const GridErrorContainer = styled.div(({ theme }) => ({
  width: '100%',
  padding: '1rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderBottom: `1px solid ${theme.palette.grey[300]}`,
}));

interface Props {
  className?: string;
}

export const GridError: FC<Props> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <GridErrorContainer className={className}>
      <QcsAlert severity="error">{t('common.tableError')}</QcsAlert>
    </GridErrorContainer>
  );
};
